import { render, staticRenderFns } from "./OptionList.vue?vue&type=template&id=2b0f26da&scoped=true&"
import script from "./OptionList.vue?vue&type=script&lang=js&"
export * from "./OptionList.vue?vue&type=script&lang=js&"
import style0 from "./OptionList.vue?vue&type=style&index=0&id=2b0f26da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0f26da",
  null
  
)

export default component.exports